import http from '@/services/api/http';

export default {
  getMostPopular(interval = '12h', count = 5) {
    // from disqus api
    return http.get(`api/Insight/MostPopular/${interval}?count=${count}`);
  },
  getAnalysis(limit = 4, offset = 0) {
    // from tumblr api
    return http.get(`api/Insight/Analysis?limit=${limit}&offset=${offset}`);
  },
  getFeeds() {
    return http.get('api/Insight/Feeds');
  },
  getMarketFeeds(marketId) {
    return http.get(`api/Insight/Feeds/Markets/${marketId}`);
  },
  getNews(limit = 5, offset = 0) {
    return http.get(`api/Insight/News?limit=${limit}&offset=${offset}`);
  },
};
